import { useMemo } from 'react';
import { GetWallets, useGetWallets, useGetWalletsBalances } from 'shared/data/wallets/v1';

import { useCompanyBasedOnUrl } from '../../useCompanyBasedOnUrl';
import { WalletAvailableCurrency } from './useWalletAvailableCurrencies.types';

export const useWalletAvailableCurrencies = (options: {
    needBalance?: boolean;
    walletFilter?: (wallet: GetWallets['response']['items'][number]) => boolean;
}) => {
    const { needBalance, walletFilter } = options;

    const { id: companyId } = useCompanyBasedOnUrl();

    const { data, isLoading } = useGetWallets({
        path: { organizationId: companyId },
    });

    const { data: walletsBalances } = useGetWalletsBalances(
        {
            path: { organizationId: companyId },
        },
        {
            enabled: needBalance,
        }
    );

    const currencies = useMemo(() => {
        return data?.items.reduce<WalletAvailableCurrency[]>((acc, wallet) => {
            if (walletFilter && !walletFilter(wallet)) {
                return acc;
            }

            const balance = needBalance
                ? walletsBalances?.items.find((balance) => balance.currency === wallet.currency.code)?.amount
                : undefined;

            acc.push({
                id: wallet.currency.code,
                walletId: wallet.id,
                currencyName: wallet.currency.name,
                balance,
            });

            return acc;
        }, []);
    }, [data, walletsBalances, needBalance, walletFilter]);

    return {
        currencies,
        isLoading,
    };
};
